<div class="gap-sm flex w-full items-center">
  <div class="flex flex-1 flex-col">
    <span class="component-medium-semibold">{{ module().nom }}</span>
    <span class="component-small-medium text-components-content-neutral-secondary">{{ module().codeModule }}</span>
  </div>
  <div>
    <hlm-radio-indicator indicator />
  </div>
</div>
<div class="gap-xs text-components-content-neutral-tertiary flex items-center">
  <ng-icon name="lucideClock" hlm size="sm" />
  <span class="text-components-content-neutral-primary">{{ module().duree | i18nPlural: heureMapping }}</span>
</div>
